import { render, staticRenderFns } from "./Emission.vue?vue&type=template&id=f55663bc&scoped=true&"
import script from "./Emission.vue?vue&type=script&lang=js&"
export * from "./Emission.vue?vue&type=script&lang=js&"
import style0 from "./Emission.vue?vue&type=style&index=0&id=f55663bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55663bc",
  null
  
)

export default component.exports